/* eslint-disable object-curly-newline */
/* eslint-disable operator-linebreak */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */
/* eslint-disable consistent-return */
// ** React Imports
import React, { Fragment, lazy } from 'react';
import { Navigate } from 'react-router-dom';
// ** Layouts
import BlankLayout from '@layouts/BlankLayout';
// import ChatbotLayout from '@layouts/ChatbotLayout';
// import VerticalLayout from '@src/layouts/VerticalLayout';
// import HorizontalLayout from '@src/layouts/HorizontalLayout';
import LayoutWrapper from '@src/@core/layouts/components/layout-wrapper';

// ** Route Components
import PublicRoute from '@components/routes/PublicRoute';
import PrivateRoute from '@components/routes/PrivateRoute';

// ** Utils
import { isObjEmpty } from '@utils';

const getLayout = {
  blank: <BlankLayout />,
  // vertical: <VerticalLayout />,
  // horizontal: <HorizontalLayout />,
  // chabotLayout: <ChatbotLayout />,
};

// ** Document title
const TemplateTitle = '%s - Vuexy React Admin Template';

// ** Default Route
// const DefaultRoute = '/dashboard';
const DefaultRoute = '/login';

const Closed = lazy(() => import('../../views/Closed'));
// const Dashboard = lazy(() => import('../../views/Dashboard'));
const Login = lazy(() => import('../../views/login/Login'));
// const Error = lazy(() => import('../../views/Error'));
// const ProjectList = lazy(() => import('../../views/project/List'));
// const ProjectForm = lazy(() => import('../../views/project/Form'));
// const DialogflowList = lazy(() => import('../../views/dialogflow/List'));
// const DialogflowForm = lazy(() => import('../../views/dialogflow/form/Form'));
// const FileList = lazy(() => import('../../views/file/List'));
// const FileForm = lazy(() => import('../../views/file/Form'));
// const UserList = lazy(() => import('../../views/user/List'));
// const UserForm = lazy(() => import('../../views/user/Form'));
// const Reports = lazy(() => import('../../views/report/Reports'));
// const Master = lazy(() => import('../../views/report/Master'));

// ** Merge Routes
const Routes = [
  {
    path: '/',
    index: true,
    element: <Navigate replace to={DefaultRoute} />,
    meta: { restricted: true },
  },
  // { path: '/dashboard', element: <Dashboard />, meta: { restricted: true } },
  // { path: '/project/list', element: <ProjectList />, meta: { restricted: true } },
  // { path: '/project/form', element: <ProjectForm />, meta: { restricted: true } },
  // { path: '/file/list', element: <FileList />, meta: { restricted: true } },
  // { path: '/file/form', element: <FileForm />, meta: { restricted: true } },
  // { path: '/user/list', element: <UserList />, meta: { restricted: true } },
  // { path: '/user/form/*', exact: true, element: <UserForm />, meta: { restricted: true } },
  // { path: '/dialogflow/list', element: <DialogflowList />, meta: { restricted: true } },
  // { path: '/dialogflow/form/*', exact: true, element: <DialogflowForm />, meta: { restricted: true } },
  // { path: '/report/reports', element: <Reports />, meta: { restricted: true, publicRoute: false } },
  // { path: '/report/master', element: <Master />, meta: { restricted: true, publicRoute: false } },
  { path: '/login', element: <Login />, meta: { layout: 'blank', restricted: true, publicRoute: true } },
  { path: '/closed', element: <Closed />, meta: { layout: 'blank', publicRoute: true } },
  // { path: '*', element: <BlankLayout />, children: [{ path: '*', element: <Error /> }] },
  { path: '*', element: <Navigate replace to="/closed" /> },
];

const getRouteMeta = (route) => {
  if (isObjEmpty(route.element.props)) {
    if (route.meta) {
      return { routeMeta: route.meta };
    }
    return {};
  }
};

// ** Return Filtered Array of Routes & Paths
const MergeLayoutRoutes = (layout, defaultLayout) => {
  const LayoutRoutes = [];

  if (Routes) {
    Routes.filter((route) => {
      let isBlank = false;
      // ** Checks if Route layout or Default layout matches current layout
      if (
        (route.meta && route.meta.layout && route.meta.layout === layout)
        || ((route.meta === undefined || route.meta.layout === undefined)
          && defaultLayout === layout)
      ) {
        let RouteTag = PrivateRoute;

        // ** Check for public or private route
        if (route.meta) {
          route.meta.layout === 'blank' ? (isBlank = true) : (isBlank = false);
          RouteTag = route.meta.publicRoute ? PublicRoute : PrivateRoute;
        }
        if (route.element) {
          const Wrapper = isObjEmpty(route.element.props) && isBlank === false ? LayoutWrapper : Fragment;

          route.element = (
            <Wrapper {...(isBlank === false ? getRouteMeta(route) : {})}>
              <RouteTag route={route}>{route.element}</RouteTag>
            </Wrapper>
          );
        }

        // Push route to LayoutRoutes
        LayoutRoutes.push(route);
      }
      return LayoutRoutes;
    });
  }
  return LayoutRoutes;
};

const getRoutes = () => {
  const defaultLayout = 'blank';
  const layouts = ['blank'];
  // const defaultLayout = layout || 'vertical';
  // const layouts = ['vertical', 'horizontal', 'blank', 'chabotLayout'];

  const AllRoutes = [];

  layouts.forEach((layoutItem) => {
    const LayoutRoutes = MergeLayoutRoutes(layoutItem, defaultLayout);

    AllRoutes.push({
      path: '/',
      element: getLayout[layoutItem] || getLayout[defaultLayout],
      children: LayoutRoutes,
    });
  });
  return AllRoutes;
};

export {
  DefaultRoute, TemplateTitle, Routes, getRoutes,
};
